module.exports = __webpack_public_path__ + "media/images/bondform_spice1-5222062a5960ea5f205e349c50a0625e.gif";